module.exports = __webpack_public_path__ + "img/background_login.6622baa1.png";